import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faTicket } from '@fortawesome/pro-duotone-svg-icons';
import { faCoin, faArrowRight } from '@fortawesome/pro-solid-svg-icons';

import { CarouselCard } from '../../../../models/carousel-card.model';

@Component({
  selector: 'mom-carousel-card',
  templateUrl: 'carousel-card.component.html',
  styleUrls: ['./carousel-card.component.scss']
})
export class CarouselCardComponent implements OnInit {
  @Input() card: CarouselCard;
  @Input() vertical: boolean;
  @Output() continue = new EventEmitter<CarouselCard>();

  counter: number;
  disableButtonInd: boolean;
  faArrowRight = faArrowRight;
  faCoin = faCoin;
  faTicket = faTicket;
  durationLength: string;

  ngOnInit(): void {
    this.durationLength = this.card.duration === '1' ? 'Minute' : 'Minutes';
    if (this.card.endDate) {
      this.counter = (new Date(this.card.endDate).getTime() - new Date().getTime()) / 1000;
      if (this.counter <= 0) {
        this.counter = 0;
        this.disableButtonInd = true;
        return;
      }
      const intervalId = setInterval(() => {
        this.counter = this.counter - 1;
        if (this.counter < 1) {
          this.disableButtonInd = true;
          clearInterval(intervalId);
        }
      }, 1000);
    }
  }
}
